import { App } from "vue";

const AutoSizeTextarea = {
  install: (app: App) => {
    app.directive("autosize", {
      // When the bound element is inserted into the DOM...
      mounted(el) {
        const textarea = el as HTMLTextAreaElement;

        function adjustTextareaHeight() {
          textarea.style.height = "auto";
          textarea.style.height = `${textarea.scrollHeight}px`;
        }
        // Autoresize the textarea based on its content

        // Listen to input events and adjust the height accordingly
        textarea.addEventListener("input", adjustTextareaHeight);

        // Initial adjustment
        adjustTextareaHeight();
      },
    });
  },
};

export default AutoSizeTextarea;
